module.exports = __webpack_public_path__ + "static/media/facebook.c2ac77b7.svg";